import {
    getTCPRolesWithRootStations,
} from "../handler/ParentDataHandler";

export async function getEmployeeTCPRolesWithRootStations() {
    let response = await getTCPRolesWithRootStations();
    let parsedResponse = {};
    try {
        if (response && response.rolesWithRootStations) {
            parsedResponse = JSON.parse(response.rolesWithRootStations);
        }
    } catch (e) {
        console.error(e);
    }
    return parsedResponse;
}





// WEBPACK FOOTER //
// ./src/components/resources/EmployeeResource.js